export const fellowshipTypeMap = {
  1: "Career Development Fellowship (CDF)",
  2: "Senior Fellowship (SF)",
  3: "EDCTP Clinical Research & Development Fellowship (R&D F)",
  4: "EDCTP-AREF Preparatory Fellowships (PF)",
  5: "Senior Fellowship Plus (SFP)",
  6: "Disease Outbreak and Epidemic Response (EPI Fellows)",
  7: "Female PhD Fellowships",
  8: "EDCTP Master's Fellowship"
};

export function getFellowshipTypeDescription(callId) {
  if (!callId) return '';
  const key = Number(callId);
  return fellowshipTypeMap[key] || '';
}
